import { render } from "./light.svg?vue&type=template&id=c9e62758?inline"
const script = {}

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__